// extracted by mini-css-extract-plugin
module.exports = {"root":"ContainerColumn_root__3Q2fM"};